// removed by extract-text-webpack-plugin
module.exports = {"background-grey":"#f6f6f6","light-grey":"#d4d4d4","grey":"#707070","black":"#000000","red":"#e40000","white":"#ffffff","fastest":".15s","linear":"cubic-bezier(0, 0, 1, 1)"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Tabs/Tabs.css
// module id = 1144
// module chunks = 0